export default __webpack_public_path__ + "media/Money.3a023140.svg";